import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SigninLandingPage from "./pages/sign-options/SignInLandingPage";
import AdminDashboard from "./pages/adminDashboard/adminDashboard";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import UserSignInPage from '../src/pages/user-pages/user-sign-in'
import UserSignUpPage from '../src/pages/user-pages/user-sign-up'
// import '../node_modules/uswds/dist/css/uswds.min.css';
import "./styles/app.scss";
import ContractRepotPage from '../src/pages/contract-report/contract-report-home'
import MainDashboard from '../src/pages/dashboard/dashboard-main-home'
import DashboardPage from '../src/pages/dashboard/dashboard-home'
import ReferencePage from '../src/pages/reference/reference-home'
import RemindersPage from '../src/pages/reminders/reminders-home'
import UploadRepotPage from '../src/pages/upload-report/upload-report-home'
import AdhocOrNewOnDemandReport from "./pages/upload-report/adhoc-or-new-report-page";
import UserManagemnetPage from '../src/pages/user-management/user-management-home'
import '@inovua/reactdatagrid-enterprise/index.css'

import ContractRepotDetailsPage from '../src/pages/contract-report/contract-report-details'
import ReportReviewHistoryPage from '../src/pages/contract-report/contract-review-history-details'
import McoActionsPage from "./pages/contract-report/mco-actions-page";
import ReviewPage from "./pages/contract-report/state-review-page";
import SftpReportDetailsPage from "./pages/sftp-reports/sftp-report-details";
import SftpReportsHomePahe from "./pages/sftp-reports/sftp-uploaded-report-home";
import ReportCatalogDetails from "./pages/reference/catalog-report-details";
import UserManagementDetails from "./pages/user-management/user-management-details";
import UserAccountChangeRequest from "./pages/user-management/user-account-change-request";
import { GlobalContextProvider } from "./GlobalContext";
import { UserProvider } from './UserContext';
import { AccessControlProvider } from '../src/utils/AccessControlContext';
import B2CUserSignIn from '../src/pages/user-pages/b2c-sign-in'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HealthCareServiceQuality from '../src/pages/dashboard/healthcare-service-quality'
import IntakeDateQuality from '../src/pages/dashboard/intake-data-quality'
import IntakeDateQualityDetails from '../src/pages/dashboard/intake-data-quality-details'
import InternalWorkManagement from '../src/pages/dashboard/internal-work-management-details'
import DashboardInternal from '../src/pages/dashboard/dashboard-home-internal'
import HealthQualityScore from '../src/pages/dashboard/health-quality-scores'
import ActionDetailsPage from '../src/pages/contract-report/action-details'

export let savedFilters = {
  ReferencePage: null,
  ContractRepotPage: null,
  RemindersPage: null,
  UserManagemnetPage: null,
};

function App({ msalInstance }) {
  const location = useLocation();

  useEffect(() => {
      if (location.pathname === "/admin-dashboard") {
          // Reset all saved filters when navigating to home
          savedFilters.ReferencePage = null;
          savedFilters.ContractRepotPage = null;
          savedFilters.RemindersPage = null;
          savedFilters.UserManagemnetPage = null;
      }
  }, [location.pathname]);
  
  return (
    <React.Fragment>
      <MsalProvider instance={msalInstance}>
        <GlobalContextProvider>
          <AccessControlProvider>
          <UserProvider>
            <main id="main">
              <div className="container-fluid">
                <div className="grid-row">
                  <div className="grid-col">
                    <ToastContainer theme="colored" autoClose={10000} />
                    <Route exact path="/"><SigninLandingPage /></Route>
                    <Route path="/b2c-user-sign-in" component={B2CUserSignIn} />
                    <Route path="/sign-in" component={SigninLandingPage} />
                    <Route path="/user-sign-in" component={UserSignInPage} />
                    <Route path="/admin-dashboard" component={AdminDashboard} />
                    <Route path="/user-sign-up" component={UserSignUpPage} />
                    <Route path="/contact-report-inventory" component={ContractRepotPage} />
                    <Route path="/main-dashboard" component={MainDashboard} />
                    <Route path="/plans-performance-dashboard" component={DashboardPage} />
                    <Route path="/reviewer-groups-dashboard" component={DashboardInternal} />
                    <Route path="/dashboard-health-care-quality" component={HealthCareServiceQuality} />
                    <Route path="/dashboard-health-quality" component={HealthQualityScore} />
                    <Route path="/dashboard-intake-data-quality" component={IntakeDateQuality} />
                    <Route path="/intake-data-quality-details" component={IntakeDateQualityDetails} />
                    <Route path="/internal-work-management-details" component={InternalWorkManagement} />
                    <Route path="/reference-data" component={ReferencePage} />
                    <Route path="/reminders-notifications" component={RemindersPage} />
                    <Route path="/upload-reports" component={UploadRepotPage} />
                    <Route path="/user-management" component={UserManagemnetPage} />
                    <Route path="/contract-report-details" component={ContractRepotDetailsPage} />
                    <Route path="/review-history-details" component={ReportReviewHistoryPage} />
                    <Route path="/adhoc-or-new-report" component={AdhocOrNewOnDemandReport} />
                    <Route path="/mco-actions" component={McoActionsPage} />
                    <Route path="/mco-review" component={ReviewPage} />
                    <Route path="/sftp-report-details" component={SftpReportDetailsPage} />
                    <Route path="/sftp-uploaded-reports" component={SftpReportsHomePahe} />
                    <Route path="/report-catalog-details" component={ReportCatalogDetails} />
                    <Route path="/user-management-details" component={UserManagementDetails} />
                    <Route path="/user-account-change-request" component={UserAccountChangeRequest} />
                    <Route path="/action-details" component={ActionDetailsPage} />
                  </div>
                </div>
              </div>
            </main>
            </UserProvider>
          </AccessControlProvider>
        </GlobalContextProvider>
      </MsalProvider>
    </React.Fragment>
  );
}

export default App;
